import { render, staticRenderFns } from "./ServiceRecord.vue?vue&type=template&id=771a4ac7"
import script from "./ServiceRecord.vue?vue&type=script&lang=js"
export * from "./ServiceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports